<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				{{ getLinkName }}
			</div>
		</div>
		<div class="separator" />
		<div v-if="link" class="content edit-link">
			<div class="main">
				<link-field :link="link" />
				<link-data-form ref="form" v-model="link" :is-waiting="isWaiting" />
			</div>
			<div class="side">
				<div class="edit-link--controls">
					<v2-button variant="outline" :to="getLinkDealsUrl">
						Edit deals: <span data-element="deals-alert">{{ getLinkDealsText }}</span>
					</v2-button>
				</div>
				<div class="edit-link--controls">
					<v2-button @click="onSave">
						Save
					</v2-button>
					<v2-button variant="red" @click="onDelete">
						Delete
					</v2-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import V2BackBtn from '@/components/v2/ui/V2BackBtn';
	import V2Button from '@/components/v2/ui/V2Button';
	import LinkDataForm from '@/components/dealLinks/LinkDataForm';
	import LinkField from '@/components/dealLinks/LinkField.vue';
	import invalidFormMessage from '@/mixins/invalidFormMessage';
	import api from '@/services/api';
	// import { DEAL_LINK_ACCESSIBILITY_OPTIONS } from '@/consts';

	export default {
		metaInfo: {
			title: 'Edit link'
		},
		components: {
			V2BackBtn,
			V2Button,
			LinkDataForm,
			LinkField
		},
		layout: 'v2default',
		mixins: [invalidFormMessage],
		data () {
			return {
				link: null,
				isWaiting: undefined
			};
		},
		computed: {
			getLinkId () {
				return  this.link?.id;
			},
			getLinkName () {
				return  this.link?.name;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: '/teaching/links',
						text: 'Deal Links'
					},
					{
						path: `/teaching/links/${this.getLinkId}`,
						text: this.getLinkName
					}
				];
			},
			getLinkDealsUrl () {
				if (this.link) {
					return `/teaching/links/${this.link?.id}/deals`;
				}
				return null;
			},
			getDealIds () {
				return this.link?.dealIds || [];
			},
			getLinkDealsText () {
				if (this.getDealIds.length > 0) {
					return `(${this.getDealIds.length})`;
				}
				return 'No deals added';
			}
		},
		watch: {},
		created () {
			this.fetchLinkData();
		},
		methods: {
			async fetchLinkData () {
				const link = await api.dealLinks.getDealLink({
					linkId: this.$route.params.linkId
				});
				if (!link) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.link = link;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			},
			async onSave () {
				const valid = await this.$refs.form.validate();

				if (!valid) {
					this.showInvalidFormMessage();
				}

				this.isWaiting = 'handleSave';
				const response = await api.dealLinks.updateDealLink({
					linkId: this.getLinkId,
					link: this.link
				});
				if (response) {
					this.$store.commit('ui/showNotification', {
						notification: 'Updated successfully.'
					});
					this.$store.commit('ui/setBreadcrumbs', {
						breadcrumbs: this.getBreadcrumbs
					});
				}
				this.isWaiting = undefined;
			},
			async onDelete () {
				if (confirm('Are you sure?')) {
					if (this.getLinkId) {
						await api.dealLinks.deleteDealLink({
							linkId: this.getLinkId
						});
					}
					this.$store.commit('ui/showNotification', {
						notification: 'Successfully deleted.'
					});
					await this.$router.push('/teaching/links');
				}
			}
		}
	};
</script>

<style lang="scss" scoped>

.edit-link {

	.side {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

  @media (max-width: 1279px) {
    display: flex;
    flex-direction: column;

    .side {
      width: 100%;
    }

    .main {
      width: 100%;
    }
  }

  &--title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 10px;
    @include font(18px, $c-darkest-navy, 700, 23px);
  }

  &--controls {
    display: flex;
    gap: 12px;

    .btn {
      border-radius: 4px;
      padding: 8px 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

			[data-element='deals-alert'] {
				padding-left: 6px;
				font-weight: bold;
			}
    }

    &-create {
      background: $c-red;
    }

    &-cancel {
      background: $c-dark-navy;
    }
  }
}

</style>
